import { ABOUT_BADGES, CREDENTIALS, MEMBERSHIPS } from "../../lib/data";
import { motion } from "framer-motion";
import { CheckCircle2, Award, Heart, Zap, Languages } from "lucide-react";

const BADGE_ICONS = [Award, Heart, Zap, Languages];

export const About = () => {
  return (
    <section id="about" className="py-20 sm:py-28 px-6 sm:px-10 lg:px-14 bg-bone-2">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="text-center mb-12"
        >
          <p className="eyebrow mb-3">About the Surgeon</p>
          <h2 className="font-sans font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink leading-tight">
            Meet Dr. Venkatsubramaniam — Best Urologist in Chennai
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="bg-paper rounded-3xl border border-line p-8 sm:p-12 shadow-[0_30px_60px_-40px_rgba(14,156,169,0.20)]"
        >
          <div className="space-y-5 text-base sm:text-lg text-ink-soft leading-relaxed max-w-4xl mx-auto">
            <p>
              Dr. Venkatsubramaniam is a Senior Urologist with over <span className="text-ink font-semibold">15 years of surgical excellence</span> in Chennai. Specializing in advanced robotic surgery, comprehensive urological care, and kidney transplantation, he combines cutting-edge technology with a patient-first approach. His meticulous technique, clear communication, and dedication to patient welfare have earned the trust of <span className="text-ink font-semibold">over 10,000 patients</span>.
            </p>
            <p>
              Certified in Robotic Surgery by <span className="text-ink font-semibold">Intuitive Surgicals (USA)</span> and trained in laparoscopy at <span className="text-ink font-semibold">Aesculap Academy (Germany)</span>, Dr. Venkat brings world-class surgical expertise to every patient. He communicates fluently in <span className="text-ink font-semibold">English, Tamil, and Hindi</span>, ensuring every patient feels understood and cared for.
            </p>
          </div>

          {/* Highlight badges */}
          <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4">
            {ABOUT_BADGES.map((b, i) => {
              const Icon = BADGE_ICONS[i] || Award;
              return (
                <div key={b.label} className="bg-bone-2 rounded-2xl p-5 border border-line">
                  <Icon size={22} className="text-forest mb-3" strokeWidth={1.6} />
                  <p className="font-sans font-bold text-sm sm:text-base text-ink leading-tight">{b.label}</p>
                  <p className="mt-1 text-xs text-ink-soft">{b.sub}</p>
                </div>
              );
            })}
          </div>
        </motion.div>

        {/* Education + Memberships */}
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="mt-12 grid lg:grid-cols-2 gap-8"
        >
          <div className="bg-paper rounded-3xl border border-line p-8">
            <p className="eyebrow mb-5">Education &amp; Certifications</p>
            <ul className="space-y-4">
              {CREDENTIALS.map((c) => (
                <li key={c.title} className="flex items-start gap-3">
                  <CheckCircle2 size={20} className="text-forest mt-0.5 shrink-0" strokeWidth={1.8} />
                  <div>
                    <p className="font-sans font-semibold text-ink">{c.title}</p>
                    <p className="text-sm text-ink-soft">{c.sub}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-paper rounded-3xl border border-line p-8">
            <p className="eyebrow mb-5">Professional Memberships</p>
            <ul className="space-y-4">
              {MEMBERSHIPS.map((m) => (
                <li key={m} className="flex items-start gap-3">
                  <Award size={18} className="text-forest mt-1 shrink-0" strokeWidth={1.8} />
                  <span className="text-sm sm:text-base text-ink">{m}</span>
                </li>
              ))}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
